module.exports = __webpack_public_path__ + "img/109.professionalism.e4097ce7.svg";